import { useAppDispatch } from 'hooks';
import { FC, useCallback, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { LoginForm } from './LoginForm';
import SectionStyled from './styles';
import { signIn, signInWithToken } from './thunk';

type Props = {};

const Login: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data) => {
      try {
        await dispatch(signIn(data));
      } catch (error) {
        throw new Error(error);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    (async () => {
      try {
        const { search } = location;
        if (search.slice(0, 7) === '?token=') {
          const token = search.slice(7);
          if (token) {
            await dispatch(signInWithToken({ token }));
          }
        }
      } catch (error) {
        throw new Error(error);
      }
    })();
  }, [dispatch, location]);

  return (
    <SectionStyled>
      <img className="background" src={'Images/login/background/login.webp'} alt="background" />
      <LoginForm onSubmit={handleSubmit} />
      <div className="rectangle">
        <div className="supportInfoContainer">
          <div className="supportInfoBox">
            <span className="underLineText">ログインについて</span>
            <br />
            協力会ヘルプデスク窓口
            <br />
            {/* 2025/02/14 FJ 3月分反映分 NO57 start */}
            平日：08:00～17:00
            <br />
            {/* 2025/02/14 FJ 3月分反映分 NO57 end */}
            <img className="phoneIcon" src={'Images/phone.svg'} alt="phoneIcon" />
            <span className="phoneNumber underLineText">0120-685-054</span>
          </div>
          <div className="supportInfoBox">
            <span className="underLineText">匠アプリ操作等について</span>
            <br />
            匠アプリヘルプデスク窓口
            <br />
            {/* 2025/02/14 FJ 3月分反映分 NO57 start */}
            平日：09:00～18:00
            <br />
            {/* 2025/02/14 FJ 3月分反映分 NO57 end */}
            <img className="phoneIcon" src={'Images/phone.svg'} alt="phoneIcon" />
            <span className="phoneNumber underLineText">0120-857-572</span>
          </div>
        </div>

        <div
          style={{
            position: 'absolute',
            bottom: 20,
            right: 30,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <button
            className="policySty"
            style={{ textDecoration: 'underline' }}
            onClick={() => {
              history.push(`/privacyPolicy/WEB`);
            }}
          >
            プライバシーポリシー
          </button>

          <span
            style={{
              fontSize: '12px',
              color: '#fff',
              marginTop: '4px',
            }}
          >
            Ver : 1.3.8
          </span>
        </div>
      </div>
    </SectionStyled>
  );
};

export default Login;
